<template>
  <div class="add-message">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="$t('file.share.message')"
      @click-left="handleClose"
    >
      <i class="iconfont icon-back" slot="left"/>
    </van-nav-bar>
    <van-field
      ref="field"
      v-model="message"
      :placeholder="$t('file.share.addMessagePlaceholder')"
      type="textarea"
      spellcheck="false"
      :maxlength="($route.query.invite && 140) ||500"
      :style="fieldStyle"
    />
    <div class="inputed">{{message.length}}/{{$route.query.invite && 140 || 500}}</div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'

export default {
  name: 'addMessage',
  i18n,
  props: {
    actionName: String,
    actionItem: Object,
    headerItem: Object,
    show: Boolean,
    description: String
  },
  data () {
    return {
      message: '',
      winHeight: window.innerHeight
    }
  },
  computed: {
    fieldStyle () {
      return {
        height: this.winHeight - 44 + 'px'
      }
    }
  },
  watch: {
    description (val, oldVal) {
      this.message = val
    },
    show (val, oldVal) {
      if (val && !oldVal) {
        this.$nextTick().then(() => {
          this.$refs.field.focus()
        })
      }
    }
  },
  mounted () {
    this.$refs.field.$refs.input.addEventListener('click', this.handleScroll)
    this.$nextTick().then(() => {
      this.$refs.field.focus()
    })
  },
  beforeDestroy () {
    this.$refs.field.$refs.input.removeEventListener('click', this.handleScroll)
  },
  methods: {
    handleClose () {
      // this.$emit('')
      this.$emit('close-add-message', this.message)
    },
    handleScroll () {
      window.scrollTo(0, 0)
      document.body.scrollTop = 0
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.add-message {
  background-color: var(--pageBgColor);
  height: 100%;
  position: relative;

  & .van-field {
    padding: 20px;
    font-size: 16px;
    padding-bottom: 50px;

    & .van-field__body {
      height: 100%;
    }

    & textarea {
      height: 100%;
    }
  }

  & .inputed {
    color: var(--secondlyText);
    position: fixed;
    bottom: 20px;
    right: 20px;
  }
}
</style>
